document.addEventListener('DOMContentLoaded', function() {
  // Reference to panorama elements
  const panoramicWrapper = document.querySelector('.panoramic-wrapper');
  const panoramicContainer = document.querySelector('.panoramic-container');
  
  // Exit if elements don't exist
  if (!panoramicWrapper || !panoramicContainer) return;
  
  // Get settings from the container's data attributes or use defaults
  const enableGyroscope = panoramicContainer.dataset.enableGyroscope !== 'false'; // Default to true if not specified
  
  // Exit if gyroscope is disabled in settings
  if (!enableGyroscope) return;
  
  const iconColor = panoramicContainer.dataset.gyroIconColor || 'white';
  const bgStyle = panoramicContainer.dataset.gyroBgStyle || 'dark';
  const position = panoramicContainer.dataset.gyroPosition || 'top-right';
  
  console.log('Gyro settings:', { iconColor, bgStyle, position }); // Debug
  
  // Create gyroscope mode toggle button
  const gyroButton = document.createElement('button');
  gyroButton.className = 'gyroscope-toggle';
  
  // Apply settings via data attributes
  gyroButton.setAttribute('data-icon-color', iconColor);
  gyroButton.setAttribute('data-bg-style', bgStyle);
  gyroButton.setAttribute('data-position', position);
  
  // Create hidden span for tracking text state
  const hiddenTextSpan = document.createElement('span');
  hiddenTextSpan.className = 'gyro-text';
  hiddenTextSpan.style.display = 'none';
  hiddenTextSpan.textContent = 'Enable Motion View';
  
  // Set the SVG as button content
  gyroButton.innerHTML = '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 502.28 502.14" width="27" height="27"><g id="QEBa7k"><g><path d="M263.13,0l24.7,2.6c108.55,15.78,196.17,103.19,211.83,211.86l2.62,23.43v26.36l-2.62,23.43c-15.41,106.96-100.31,193.57-206.9,211.14l-27.75,3.32h-27.62l-27.75-3.32C101.51,480.89,15.94,392.08,2.1,283.31l-1.97-19.68c.31-8.33-.41-16.79,0-25.11C6.48,110.52,111.33,6.17,239.28,0h23.85ZM347.86,131.18c-12.94-52.9-65.46-149.6-132.01-102.82-31.92,22.44-50.14,66.4-61.32,102.5,11.05-1.34,21.98-3.81,33.05-5.24,39.84-5.13,82.31-5.37,122.23-.64,12.76,1.51,25.42,3.94,38.05,6.2ZM195.96,23.84c.06-.07.23-1.32-.3-1.23C111.2,43.35,43.18,111.25,22.73,195.83l13.8-12.87c28.55-23.57,63.48-37.59,98.92-47.33,11.66-39.83,27.88-81.84,58.62-110.88.66-.63,1.82-.83,1.89-.91ZM416.69,84.33c-29.87-29.69-68.52-51.52-109.62-61.1,30.83,29.94,48.48,70.63,59.34,111.7.27.65.81.85,1.39,1.12,4.19,1.96,12.61,3.38,17.58,5.01,30.46,9.98,60,23.84,84.26,45.04l10.03,9.73c-10.44-41.98-32.35-81.06-62.99-111.5ZM352.74,149.53c-66.16-15.59-136.92-15.54-203.09,0-15.57,66.14-15.64,136.97,0,203.09,66,15.7,137.09,15.7,203.09,0,15.67-66.02,15.64-137.07,0-203.09ZM131.31,154.41c-28.44,8.55-58.73,20.58-81.89,39.56C.36,234.19,8.22,279.69,57.68,314.35c22.05,15.45,47.57,25.8,73.32,33.39l-5.24-33.05c-5.89-47.97-5.3-97,2.6-144.72.86-5.19,2.22-10.34,2.95-15.56ZM461.08,300.9c47.75-45.72,20.91-91.09-27.03-120.01-19.51-11.77-41.13-20.06-62.96-26.48,10.2,51.06,12.35,104.09,6.19,155.9-1.49,12.56-3.82,25.02-6.2,37.42,32.17-9.34,65.57-23.44,89.99-46.83ZM195.34,478.91c-31.12-30-48.31-70.93-59.62-112.04-41.2-11.74-82.28-28.51-112.35-59.94,19.14,83.48,88.44,152.94,171.98,171.98ZM419.04,415.13c29.07-29.82,50.94-67.25,60.01-108.2-29.89,31.15-70.85,48.39-111.92,59.58-12.04,41.23-28.45,82.24-60.05,112.39,4.1-.3,8.41-1.77,12.41-2.96,37.75-11.25,72.21-32.76,99.56-60.82ZM347.86,370.96c-52.76,10.89-107.48,12.1-160.91,5.56l-32.42-5.24c9.1,29.87,21.81,61.19,42.37,85.05,36.04,41.83,78.59,38.2,112.03-4.11,18.54-23.45,30.66-52.73,38.93-81.26Z"/><path d="M249.15,151.42c3.32-.7,4.77.25,7.5,1.63,26.48,13.37,52.28,33.51,78.87,47.29,2.15,1.37,3.56,3.88,3.6,6.45v88.57c-.04,2.58-1.46,5.08-3.6,6.45-26.43,13.85-52.06,33.74-78.48,47.06-2.92,1.47-4.29,2.6-7.89,1.87l-82.64-49.17c-1.89-1.46-3.2-3.79-3.21-6.21v-88.57c0-4.56,3.49-6.2,6.74-8.32,25.64-16.68,53.18-30.79,79.11-47.05ZM187.81,206.52l63.17,38.77,63.61-37.85-63.18-38.47-63.61,37.55ZM243.04,259.23c-21.4-11.91-42.29-25.11-63.4-37.66v68.73l63.4,37.97v-69.04ZM259.36,328.28l63.4-37.97v-68.73c-21.14,12.51-41.91,25.79-63.4,37.66v69.04Z"/></g></g></svg>';
  
  // First append the hidden span to the button
  gyroButton.appendChild(hiddenTextSpan);
  
  // Then append the button to the container
  panoramicContainer.appendChild(gyroButton);
  
  // Double-check the attributes after adding to DOM
  console.log('Button attributes:', {
    'data-icon-color': gyroButton.getAttribute('data-icon-color'),
    'data-bg-style': gyroButton.getAttribute('data-bg-style'),
    'data-position': gyroButton.getAttribute('data-position')
  });
  
  // Variables for gyroscope mode
  let gyroscopeActive = false;
  let initialOrientation = null;
  let maxRotation = 20; // Reduced for more precise control
  let baseTransform = 0; // Store manual position
  let sensitivityMultiplier = 2; // Increase to reach edges more easily
  let lastFrameTime = 0; // For throttling updates
  let animationFrameId = null; // For smoother animation
  let targetPosition = 0; // Target position for smooth animation
  let currentPosition = 0; // Current position for smooth animation
  
  // Check if DeviceOrientation is available and device is mobile
  const hasDeviceOrientation = 'DeviceOrientationEvent' in window;
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const needsPermission = isIOS && typeof DeviceOrientationEvent.requestPermission === 'function';
  
  // Detect if device is likely a desktop/laptop
  const isDesktop = window.innerWidth >= 1024 || 
                    (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  
  // Hide button if device doesn't support orientation or is a desktop device
  if (!hasDeviceOrientation || isDesktop) {
    gyroButton.style.display = 'none';
  }
  
  // Function to center the panorama view
  function centerPanorama() {
    const panoramaWidth = panoramicWrapper.scrollWidth;
    const containerWidth = panoramicContainer.clientWidth;
    
    if (panoramaWidth > containerWidth) {
      // Calculate center position
      const centerPosition = -(panoramaWidth - containerWidth) / 2;
      
      // Apply centering with smooth transition
      panoramicWrapper.style.transition = 'transform 0.5s ease-out';
      panoramicWrapper.style.transform = `translateX(${centerPosition}px)`;
      
      // Update current position
      currentPosition = centerPosition;
      targetPosition = centerPosition;
    }
  }
  
  // Handle gyroscope permission and activation
  gyroButton.addEventListener('click', function() {
    // If gyroscope is already active, turn it off
    if (gyroscopeActive) {
      deactivateGyroscope();
      return;
    }
    
    // Center the panorama first
    centerPanorama();
    
    // After a slight delay to allow centering transition to complete
    setTimeout(() => {
      // Store current transform as base transform
      const currentTransform = getComputedStyle(panoramicWrapper).transform;
      if (currentTransform !== 'none') {
        const matrix = new DOMMatrix(currentTransform);
        baseTransform = matrix.e; // Get the X translation
        currentPosition = baseTransform;
        targetPosition = baseTransform;
      }
      
      // Request permission on iOS 13+
      if (needsPermission) {
        DeviceOrientationEvent.requestPermission()
          .then(response => {
            if (response === 'granted') {
              activateGyroscope();
            } else {
              alert('Permission to use motion sensors was denied.');
            }
          })
          .catch(console.error);
      } else {
        // For non-iOS or older iOS versions
        activateGyroscope();
      }
    }, 500); // Wait for the centering transition to complete
  });
  
  function activateGyroscope() {
    gyroscopeActive = true;
    initialOrientation = null;
    gyroButton.classList.add('active');
    gyroButton.querySelector('.gyro-text').textContent = 'Disable Motion View';
    window.addEventListener('deviceorientation', handleDeviceOrientation);
    
    // Start animation loop for smooth movement
    if (!animationFrameId) {
      animationFrameId = requestAnimationFrame(updatePosition);
    }
  }
  
  function deactivateGyroscope() {
    gyroscopeActive = false;
    gyroButton.classList.remove('active');
    gyroButton.querySelector('.gyro-text').textContent = 'Enable Motion View';
    window.removeEventListener('deviceorientation', handleDeviceOrientation);
    
    // Stop animation loop
    if (animationFrameId) {
      cancelAnimationFrame(animationFrameId);
      animationFrameId = null;
    }
  }
  
  function handleDeviceOrientation(event) {
    if (!gyroscopeActive) return;
    
    // Ensure we don't process too many events - throttle updates
    const now = performance.now();
    if (now - lastFrameTime < 16) { // Aim for ~60fps
      return;
    }
    lastFrameTime = now;
    
    // Use gamma (left to right tilt) for horizontal movement
    let gamma = event.gamma; // Range: -90 to 90
    
    // Store initial orientation as reference point
    if (initialOrientation === null) {
      initialOrientation = gamma;
    }
    
    // Calculate relative movement from initial position
    let relativeTilt = gamma - initialOrientation;
    
    // Clamp the tilt value to our maximum rotation
    relativeTilt = Math.max(-maxRotation, Math.min(maxRotation, relativeTilt));
    
    // Convert tilt to panorama position
    // Calculate how much of the panorama is "extra" beyond the viewport
    const panoramaWidth = panoramicWrapper.scrollWidth;
    const containerWidth = panoramicContainer.clientWidth;
    const extraWidth = panoramaWidth - containerWidth;
    
    if (extraWidth > 0) {
      // Map the tilt range (-maxRotation to maxRotation) to panorama position
      // Increased sensitivity to reach edges
      const percentage = ((relativeTilt * sensitivityMultiplier) + maxRotation) / (maxRotation * 2);
      
      // Calculate overshoot allowance to ensure we can reach edges
      const overshootPercentage = Math.min(1, Math.max(0, percentage));
      
      // Calculate target position with sensitivity multiplier to reach edges
      targetPosition = -(overshootPercentage * extraWidth);
    }
  }
  
  // Smooth animation function using requestAnimationFrame
  function updatePosition() {
    if (gyroscopeActive) {
      // Smooth easing toward target position
      const easing = 0.15; // Smaller = smoother but slower
      const delta = targetPosition - currentPosition;
      
      if (Math.abs(delta) > 0.1) {
        currentPosition += delta * easing;
        
        // Apply the transform directly without transition for smoother motion
        panoramicWrapper.style.transition = 'none';
        panoramicWrapper.style.transform = `translateX(${currentPosition}px)`;
      }
      
      // Continue the animation loop
      animationFrameId = requestAnimationFrame(updatePosition);
    }
  }
  
  // Handle visibility change (tab switching, etc.) to reset orientation reference
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible' && gyroscopeActive) {
      initialOrientation = null;
      // Re-center if coming back to visible state
      if (gyroscopeActive) {
        centerPanorama();
      }
    }
  });
  
  // Handle orientation change to reset reference
  window.addEventListener('orientationchange', function() {
    initialOrientation = null;
    // Re-center on orientation change
    if (gyroscopeActive) {
      centerPanorama();
    }
  });
});